module.exports = __webpack_public_path__ + "h5/img/dfk.451226d7.png";